/* Recalculate after the theme has committed an asynchronous variant change. */
(() => {
  let timer;
  document.addEventListener('variant:change', () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (document.querySelector('.product-info .joy-points-calculator__block') &&
          typeof window.avadaJoyRerenderCalculator === 'function') {
        window.avadaJoyRerenderCalculator();
      }
    }, 50);
  });
})();

/* Open the native gift program; Joy handles eligibility and confirmation. */
(() => {
  let opening = false;
  document.addEventListener('click', async (event) => {
    const link = event.target.closest('[data-f52-joy-program]');
    if (!link) return;
    event.preventDefault();
    if (opening) return;
    opening = true;
    try {
      const drawer = link.closest('cart-drawer');
      if (typeof drawer?.hide === 'function') await drawer.hide();
      if (typeof window.joyInstance?.openRedeemProgram === 'function') {
        window.joyInstance.openRedeemProgram(link.dataset.f52JoyProgram);
      } else {
        // Joy's supported deep link also works while the widget initializes.
        window.location.hash = 'joy-ways-to-redeem';
      }
    } finally {
      opening = false;
    }
  });
})();
/* Localize the cart point unit when Joy falls back to its English label. */
(() => {
  const locale = document.documentElement.lang.toLowerCase().split('-')[0];
  const copy = {
    ja: { unit: 'ポイント', redeem: 'ポイントを交換' },
    es: { unit: 'puntos', redeem: 'Canjear puntos' },
    fr: { unit: 'points', redeem: 'Utiliser mes points' },
    vi: { unit: 'điểm', redeem: 'Đổi điểm' },
    de: { unit: 'Punkte', redeem: 'Punkte einlösen' }
  }[locale];
  if (!copy) return;
  const init = () => {
    document.querySelectorAll('cart-drawer').forEach(drawer => {
      let queued = false;
      const translate = () => {
        queued = false;
        drawer.querySelectorAll('.Avada-Joy-Redeem-Inline__balance-value').forEach(el => {
          for (const node of el.childNodes) {
            if (node.nodeType !== Node.TEXT_NODE) continue;
            const value = node.nodeValue.replace(/\s*\bpoints?\b/gi, locale === 'ja' ? copy.unit : ' ' + copy.unit);
            if (value !== node.nodeValue) node.nodeValue = value;
          }
        });
        drawer.querySelectorAll('.Avada-Joy-Redeem-Inline__redeem-button').forEach(el => {
          if (el.textContent.trim() !== copy.redeem) el.textContent = copy.redeem;
        });
      };
      new MutationObserver(() => {
        if (!queued) { queued = true; requestAnimationFrame(translate); }
      }).observe(drawer, { childList: true, subtree: true, characterData: true });
      translate();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
